import { h, defineComponent, ref, watch } from 'vue';
import { d, t } from '@/ui/i18n/i18n';
import { box, container, loader, pageSubtitle, pageTitle } from '@/ui/components';
import { useTask } from '@/ui/concerns';
import { get } from '@/services/api/resources/notification';
import { emptyNotification } from '@/entities/notification';

interface StringIdProps {
  id: string;
}

/**
 * it is marked as read on opening, no button required
 */
export const NotificationDetailPage = defineComponent<StringIdProps>({
  name: 'NotificationDetailPage',
  props: ['id'],
  setup(props) {
    // create empty record
    const record = ref(emptyNotification);

    // get record
    const getRecord = useTask(
      () => get(props.id),
      ({ data }) => {
        record.value = data.data;
      },
    );
    watch(ref(props.id), getRecord.run);

    return function render() {
      return container(
        [
          pageTitle(t('notifications.details')),
          box([loader('div', getRecord, [
            pageSubtitle(record.value.subject),
            h('p', { class: 'subtitle is-size-7 has-text-grey' }, d(record.value.createdAt)),
            h('div', { class: 'content' }, [
              h('p', { domProps: { innerHTML: record.value.message } }),
            ]),
          ], false),
          ]),
        ],
        'narrow',
      );
    };
  },
});
